// extracted by mini-css-extract-plugin
module.exports = {"body":"SessionServiceEditModal_body__2lH_2","service":"SessionServiceEditModal_service__2iCf4","warning":"SessionServiceEditModal_warning__3CZSz"};